var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWelltoryLogoBlack = function SvgWelltoryLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.664 28.016c-1.902 0-3.162-.367-4.33-.827v-2.71c1.397.62 3.024.896 4.376.896 2.635 0 3.505-1.355 3.505-3.514v-1.033c-.756 1.148-1.878 1.906-3.551 1.906-3.276 0-4.605-1.93-4.605-5.719v-6.867h3.139v6.982c0 2.044.641 3.123 2.268 3.123 1.627 0 2.749-1.378 2.749-3.123v-6.982h3.139v11.805c0 3.835-2.428 6.063-6.69 6.063ZM110.332 22.642V10.15h3.139v1.998c.802-1.355 2.085-2.32 3.849-2.32v3.146a2.882 2.882 0 0 0-.641-.068c-1.925 0-3.185 1.607-3.208 3.996v5.741h-3.139ZM96.11 17.176v-1.515c0-3.928 2.566-5.834 5.888-5.834s5.934 1.906 5.934 5.834v1.515c0 3.904-2.612 5.81-5.934 5.81s-5.889-1.906-5.889-5.81Zm3.207-1.538v1.538c0 2.25 1.008 3.33 2.681 3.33 1.672 0 2.704-1.08 2.704-3.33v-1.538c0-2.251-1.032-3.308-2.704-3.308-1.673 0-2.68 1.057-2.68 3.307ZM88.4 18.738v-6.132h-1.994v-2.457H88.4V6.566h3.139v3.583h3.001v2.457H91.54v5.673c0 1.561.527 2.044 1.741 2.044.458 0 1.031-.046 1.444-.161v2.572c-.528.138-1.421.252-2.131.252-2.75 0-4.193-1.538-4.193-4.248ZM80.566 19.312V5.302h3.14v13.16c0 1.401.228 1.883 1.19 1.883.46 0 .871-.069 1.124-.183v2.549c-.482.16-1.238.276-1.88.276-2.405 0-3.574-1.126-3.574-3.675ZM73.516 19.312V5.302h3.139v13.16c0 1.401.229 1.883 1.191 1.883.458 0 .87-.069 1.123-.183v2.549c-.481.16-1.237.276-1.879.276-2.406 0-3.574-1.126-3.574-3.675ZM65.534 9.827c3.322 0 5.659 1.883 5.659 5.696v2.02h-8.088c.137 1.999 1.375 2.849 3.368 2.849 1.512 0 2.75-.115 4.445-1.011v2.457c-1.512.85-2.887 1.149-4.95 1.149-3.849 0-6.048-2.044-6.048-5.81V15.66c0-3.698 2.291-5.834 5.614-5.834Zm0 2.503c-1.536 0-2.383 1.034-2.43 3.055h4.904c-.023-2.113-.825-3.055-2.474-3.055ZM40.1 10.148h3.116l2.154 9.302 2.864-9.302h2.772l2.818 9.256 2.131-9.256h3.002l-3.529 12.724h-3.185l-2.658-8.842-2.772 8.842h-3.139L40.1 10.148Z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#welltory-logo-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.947c0-4.182 0-6.273.814-7.87A7.467 7.467 0 0 1 4.077.814C5.674 0 7.765 0 11.947 0h8.106c4.182 0 6.273 0 7.87.814a7.467 7.467 0 0 1 3.263 3.263C32 5.674 32 7.765 32 11.947v8.106c0 4.182 0 6.273-.814 7.87a7.467 7.467 0 0 1-3.263 3.263c-1.597.814-3.688.814-7.87.814h-8.106c-4.182 0-6.273 0-7.87-.814a7.467 7.467 0 0 1-3.263-3.263C0 26.326 0 24.235 0 20.053v-8.106Z",
    fill: "#151A22"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#welltory-logo-black_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#welltory-logo-black_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.46 12.871c-.185-4.531-3.474-5.444-5.01-5.4-2.05 0-3.831.708-5.35 2.123-.502.469-1.349.407-1.847-.068-2-1.91-5.346-2.165-7.144-1.263C6.008 9.318 5.08 11.16 5.08 13.136c0 7.903 8.027 13.166 11.187 13.166 2.634 0 11.467-6.715 11.193-13.431Z",
    fill: "url(#welltory-logo-black_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.523 11.029C6.39 9.317 8.76 8 10.342 7.869c1.399-.117 3.417.076 5.14 1.858.387.4 1.012.487 1.399.09.675-.694 1.29-1.387 3.468-2.08-1.58.79-2.502 1.58-4.345 3.687-1.276 1.457-2.897 2.239-5.267 2.239-1.449 0-4.06-.627-4.214-2.634Z",
    fill: "#C92E00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.98 16.56c.127.26-.004.484-.302.629-.298.144-.625.026-.75-.235-.127-.26-.005-.563.293-.708.298-.144.633.053.76.313ZM14.463 20.252c-.084-.277.079-.479.396-.576.316-.097.666.163.75.44.085.276-.127.464-.444.561-.316.098-.617-.149-.702-.425ZM8.632 17.35a.514.514 0 0 1 .322-.642c.317-.097.706.118.79.395.085.276-.17.414-.487.511-.317.097-.592-.157-.625-.264Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.179,
    cy: 12.241,
    rx: 0.224,
    ry: 0.263,
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.85 17.901c0 .218-.189.395-.48.395-.29 0-.526-.177-.526-.395 0-.218.236-.29.527-.29.29 0 .479.072.479.29ZM20.614 20.773c0 .218-.188.395-.48.395-.29 0-.573-.177-.573-.395 0-.218.283-.421.574-.421.29 0 .479.203.479.42Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.092-.488C6.44-.711 4.432-.24 2.73.924 4.706 2.051 7.245 4.16 8.657 7.257c.795 1.744.424 4.506 2.402 5.492 2.182 1.088 4.002-1.455 4.52-2.535.094-.657.028-2.394-.989-4.084-1.271-2.112-2.106-2.1-4.661-4.365C8.657.638 8.665-.411 8.092-.488Z",
    fill: "url(#welltory-logo-black_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.475 11.95c0 .218-.309.395-.527.395a.395.395 0 0 1 0-.79c.218 0 .527.177.527.395Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.162 8.332c.243-.01.455.35.466.61.01.26-.178.479-.421.489-.244.01-.45-.193-.46-.453-.011-.26.171-.636.415-.646Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 4.126c.244-.01.46.462.475.802.014.34-.172.623-.416.633-.244.01-.452-.258-.466-.597-.014-.34.164-.829.407-.838ZM17.558 6.927c.074.1-.033.304-.152.39-.118.087-.273.076-.347-.025-.074-.1-.037-.252.08-.338.12-.087.346-.128.42-.027Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 8.285c.084.117-.014.333-.132.42a.263.263 0 0 1-.368-.054.263.263 0 0 1 .06-.367c.118-.087.354-.115.44.001Z",
    fill: "#FF6B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.567 6.402c-.116-.086-.087-.322 0-.44a.263.263 0 0 1 .368-.058c.116.086.139.251.052.369-.088.118-.305.215-.42.129Z",
    fill: "#FEA900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.58 2.205c-.143-.012-.142-.118-.13-.264.01-.146.01-.31.153-.3.144.012.251.139.24.285-.011.146-.119.29-.262.279Z",
    fill: "#CC5616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.19 4.97c-.115-.086-.038-.212 0-.263.117-.158.328-.446.395-.396.096.071.026.338-.09.495-.063.086-.189.25-.305.164Z",
    fill: "#E39932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.446 2.863c-.316-.21-.527-.395-.79-.395-.79 0-.527 1.185-.264 1.58.264.395 1.054.659 1.317.527.263-.132.263-.395.263-.658 0-.264-.131-.79-.526-1.054Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.792 6.682c-.659-.493-1.405-1.624-1.844-2.238-.227-.318-.392 0-.395.263 0 .264-.028 2.289.527 3.029.79 1.053 1.185 1.053 1.712.527.335-.336.526-1.186 0-1.58Z",
    fill: "#FF5B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.895 9.052c0-.263-.527-.79-.922-1.317-.316-.421-.746-.439-.922-.395-.088 0-.29.08-.395.395-.132.395.132.79.395.922.118.059.659.132 1.054.527.335.335.79.131.79-.132ZM14.947 11.677c-.442.367-1.373.92-1.997 1.13a.265.265 0 0 1-.328-.164c-.228-.582-.42-1.164-.304-1.746.228-1.141.746-1.098 1.054-.922.576.329 1.244.39 1.649 1.407a.258.258 0 0 1-.074.295Z",
    fill: "#FF6B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "welltory-logo-black_svg__b",
    x: -12.308,
    y: -7.934,
    width: 55.576,
    height: 57.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.901
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.901
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.327091 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3006_11150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3006_11150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "welltory-logo-black_svg__c",
    x: 1.13,
    y: 3.519,
    width: 26.337,
    height: 22.783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.95,
    dy: -3.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_3006_11150"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "welltory-logo-black_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.36834 19.10305 -18.20969 2.25758 13.635 9.306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#B80747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "welltory-logo-black_svg__e",
    x1: 9.159,
    y1: 9.001,
    x2: 4.798,
    y2: -0.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "welltory-logo-black_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgWelltoryLogoBlack;